export var JobStatus;
(function (JobStatus) {
    JobStatus["ERROR"] = "ERR";
    JobStatus["PROCESSING"] = "PRCS";
    JobStatus["INIT"] = "INIT";
    JobStatus["DONE"] = "DONE";
})(JobStatus || (JobStatus = {}));
//# sourceMappingURL=JobStatus.js.map